export { default } from './AWSTranscribePoc';
